import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Divider from "@material-ui/core/Divider";

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: (style) => (style.translationStyles1 ? "265px" : "254px"),
    direction: (style) => (style.translationStyles1 ? "rtl" : "ltr")
  },
  cardHeaderRoot: {
    background: "#FBF6EC 0% 0% no-repeat padding-box",
    border: "1px solid #F0F0F0",
    opacity: 1,
    padding: "14px"
  },
  cardHeaderTitle: {
    textAlign: (style) => (style.translationStyles1 ? "right" : "left"),
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    lineHeight: "22px",
    fontSize: "16px",
    fontWeight: 600,
    fontFamily: "Open Sans",
    paddingRight: (style) => (style.translationStyles1 ? "10px" : "unset")
  },
  cardContentRoot: {
    paddingTop: "9px",
    paddingBottom: "9px",
    paddingRight: "12.5px",
    paddingLeft: "12.5px"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(180deg)"
  },
  cardActionsRoot: {
    height: "30px",
    // padding: "10px 12.5px",
    "&:hover": {
      cursor: "pointer",
      // backgroundColor: "#FBF6EC",
      backgroundColor: (theme) => theme.backgroundColor
    }
  },
  logoutTextTypo: {
    textAlign: "left",
    font: "normal normal 600 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1,
    fontWeight: 600,
    fontFamily: "Open Sans",
    "&:hover": {
      cursor: "pointer"
    }
  },
  avatar: {
    // backgroundColor: red[500],
    marginRight: "0px"
  },
  lastLogin: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#000000"
    // marginLeft: "12.5px",
  },
  lastLoginTime: {
    textAlign: "left",
    font: "normal normal normal 12px/17px Open Sans",
    letterSpacing: "0px",
    color: "#606060",
    "font-style": "italic !important"
  },
  dateLabelDiv: {
    width: "40%"
  },
  dateLabelValue: {
    width: "40%"
  },
  sideBySide: {
    display: "flex"
  },
  dividerText: {
    textAlign: (style) => (style.translationStyles1 ? "right" : "left"),
    // textAlign: "right",
    letterSpacing: "0px",
    color: "#606060",
    opacity: "1",
    lineHeight: "14px",
    fontSize: "10px",
    // marginLeft: "14px",
    marginTop: "12px"
  },
  dividerCls: {
    // width: "-webkit-fill-available",
    width: "-moz-available",
    marginTop: "-8px",
    // marginLeft: "40%",
    marginLeft: (style) => (style.translationStyles1 ? "unset" : "30%"),
    marginRight: (style) => (style.translationStyles1 ? "30%" : "unset")
  }
}));

const LoginMenu = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  const classes = useStyles({ ...(props?.menuStyle || {}), translationStyles1 });

  const lastLoginLabelInline = {
    "font-style": "italic",
    position: "relative",
    // width: '100%',
    paddingRight: 0,
    paddingLeft: 0,
    flexGrow: translationStyles1 ? "unset" : "0.7"
  };

  return (
    <Card className={classes.root}>
      <CardHeader
        classes={{
          title: classes.cardHeaderTitle,
          avatar: classes.avatar,
          root: classes.cardHeaderRoot
        }}
        style={props.menuStyle}
        avatar={props.avatar}
        title={props.greeting}
        //   subheader="September 14, 2016"
      />
      <CardContent classes={{ root: classes.cardContentRoot }}>
        <div className={"row " + classes.sideBySide}>
          <Typography
            // sx={{ mt: 0.5, ml: 9 }}
            color="text.secondary"
            display="block"
            variant="caption"
            className={classes.lastLogin + " col"}
            style={lastLoginLabelInline}
          >
            {props.dateLabel}&nbsp;
          </Typography>
          <Typography
            // sx={{ mt: 0.5, ml: 9 }}
            color="text.secondary"
            display="block"
            variant="caption"
            className={classes.lastLoginTime + " col"}
          >
            {props.dateValue}
          </Typography>
        </div>
        <div className={"row "}>
          <Typography className={classes.dividerText}>{props.separatorText}</Typography>
          <Divider variant="inset" component="hr" className={classes.dividerCls} />
          {/* <hr/> */}
          {/* <div className={"col " + dividerClasses.dividerDiv}> */}
          {/* <Divider /> */}
          {/* </div> */}
        </div>
      </CardContent>
      <CardActions
        className={classes.cardActionsRoot}
        // style={props.menuStyle}
        disableSpacing
        onClick={() => props?.logoutFunc()}
      >
        <IconButton aria-label={props.logoutLabel}>{props.logoutIcon}</IconButton>
        <Typography className={classes.logoutTextTypo}>{props.logoutLabel}</Typography>
      </CardActions>
    </Card>
  );
};

export default LoginMenu;
